/**
 * @generated SignedSource<<8dfea83acfdd8068d223426f63f2b5c5>>
 * @relayHash 4369f38ca9ebd1685a3f27ccd7a2e71d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4369f38ca9ebd1685a3f27ccd7a2e71d

import { ConcreteRequest } from 'relay-runtime';
export type ProcessedStatus = "FAILED" | "ONGOING" | "SUCCEEDED";
export type useAtossFileUploadQuery$variables = Record<PropertyKey, never>;
export type useAtossFileUploadQuery$data = {
  readonly atossFileUpload: {
    readonly fileHash: string | null;
    readonly id: string;
    readonly processedError: string | null;
    readonly processedOn: string | null;
    readonly processedStatus: ProcessedStatus | null;
    readonly uploadedAt: string | null;
    readonly uploadedBy: string | null;
  };
};
export type useAtossFileUploadQuery = {
  response: useAtossFileUploadQuery$data;
  variables: useAtossFileUploadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AtossFileUpload",
    "kind": "LinkedField",
    "name": "atossFileUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadedBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileHash",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "processedStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "processedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "processedError",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAtossFileUploadQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useAtossFileUploadQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "4369f38ca9ebd1685a3f27ccd7a2e71d",
    "metadata": {},
    "name": "useAtossFileUploadQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "83a6d3f6119789eca1498dcf0fa74243";

export default node;
